import { ASC_ORDER, DESC_ORDER, ENGLISH, GERMAN } from '@/helpers/constants';

export type FiltersConfig = {
  filterOverview: string;
  pillFilterOverview: string;
  rowsPerPageOverview: string;
  sortOverview: string;
};

type PlantFilter = {
  dialogPlantId: string;
  plantName: string;
  wkzNumber: string;
};

export type FiltersOverview = {
  columnName: string;
  value: string | PlantFilter[] | string[];
}[];

export type SortingDirection = typeof ASC_ORDER | typeof DESC_ORDER;

export type SortOverview = {
  columnName: string;
  direction: SortingDirection;
};

export type GlobalFilters = {
  filterOverview?: string;
  sortOverview?: string;
  pillFilterOverview?: string;
  orderColumnsOverview?: string;
  widthColumnsOverview?: string;
  visibilityColumnsOverview?: string;
};

export interface TreeDataConfigOverview {
  columnExpanded: string;
  childrenProperty: string;
}

export type VisibilityColumnsOverview = {
  columnName: string;
  visible: boolean;
};

export type ColumnExtensionOverview = {
  columnName: string;
  width: string;
  extraWidthTooptip?: string;
  visible?: boolean;
};

export enum FilterKeysToTranslate {
  AFFECTS_CHINA = 'affectsChina',
  CLASSIFICATION = 'classification',
  CUSTOMER_RELEVANCY = 'customerRelevancy',
  BLOCKING_RECOMMENDATION = 'blockingRecommendation',
  SOURCE = 'source',
}

export type LanguageTranslations = {
  [ENGLISH]: string;
  [GERMAN]: string;
};

export type FilterOptions = {
  options: Record<string, LanguageTranslations>;
};

export type TableTranslations = {
  [key in FilterKeysToTranslate]: FilterOptions
};

export type FormatterData<T> = {
  lang: string;
  options: T;
};
